import type {
	AgentChatAssistantMessage,
	AgentChatAssistantPart,
	AgentChatTextPart,
} from "./types";

function isTextPart(part: AgentChatAssistantPart): part is AgentChatTextPart {
	return part.type === "text";
}

export function getAssistantMessageCopyText(
	message: AgentChatAssistantMessage,
): string {
	const chunks: string[] = [];

	for (const part of message.parts) {
		if (part.type === "text" || part.type === "reasoning") {
			if (part.text) {
				chunks.push(part.text);
			}
			continue;
		}

		if (part.type === "generated-image") {
			const label = part.modelLabel ?? part.modelId;
			if (part.status === "ready") {
				chunks.push(`[Generated image: ${label}]`);
			} else if (part.status === "error") {
				chunks.push(
					`[Image generation failed: ${label}${part.errorMessage ? ` — ${part.errorMessage}` : ""}]`,
				);
			}
		}
	}

	return chunks.join("\n\n");
}

export function getAssistantMessageDragText(
	message: AgentChatAssistantMessage,
): string {
	return message.parts
		.filter(isTextPart)
		.map((part) => part.text)
		.join("\n\n");
}

export function canDragMessageText(text: string): boolean {
	return text.trim().length > 0;
}
